<template>
  <div class="cooperation-accounts-detail-list-container">
    <div>
      <div class="text-content">
        <span
          >结算日期 ：{{
            item.balanceDate && moment(item.balanceDate).format('YYYY-MM-DD')
          }}</span
        >
      </div>
      <span
        :class="
          item && item.approvestate == '已审核'
            ? 'text-icon-gray'
            : 'text-icon-gold'
        "
        >{{ item && item.approvestate }}</span
      >
    </div>
    <template v-if="item.approvestate == '已审核'">
      <div class="report-title">
        <div class="left">
          <p>
            结算申报金额： <span>{{ item && item.yfapplyamount | money2 }}</span>
          </p>
          <!-- <p>
            结算调整金额： <span>{{ item && item.adjustamount | money2 }}</span>
          </p> -->
           <p>
            保修金额： <span>{{ item && item.bxamount | money2 }}</span>
           </p>
        </div>
        <div class="right" v-if="item.approvestate == '已审核'">
          <p>
            结算审定金额： <span>{{ item && item.totalamount | money2 }}</span>
          </p>
          <!-- <p>
            保修金额： <span>{{ item && item.bxamount | money2 }}</span>
          </p> -->
        </div>
      </div>
    </template>
    <template v-else>
      <p style="margin-top:10px">
        结算申报金额： <span>{{ item && item.yfapplyamount | money2 }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'cooperation-accounts-detail-list',
  props: {
    isAudit: {
      type: Boolean,
      default: () => true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      moment
    };
  },
  mounted() {},

  components: {},

  methods: {}
};
</script>

<style scoped lang="scss">
.cooperation-accounts-detail-list-container {
  color: #666666;
  font-size: 26px;
  padding: 20px;
  border-bottom: 1px solid #f2f2f2;
  .text-content {
    width: 85%;
    display: inline-block;
  }
  .text-icon-gold {
    width: 105px;
    height: 40px;
    display: inline-block;
    background: url('../../../common/images/visa-change/gold-icon.png')
      no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    padding-left: 10px;
    color: white;
    line-height: 40px;
    font-size: 22px;
    position: absolute;
    right: 0px;
  }
  .text-icon-gray {
    width: 105px;
    height: 40px;
    display: inline-block;
    background: url('../../../common/images/visa-change/gray-icon.png')
      no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    padding-left: 10px;
    color: white;
    line-height: 40px;
    font-size: 22px;
    position: absolute;
    right: 0px;
  }
  .report-title {
    height: 150px;
    width: 100%;
    background: white;
    display: flex;
    padding: 30px;
    padding-left: 0px;
    .left {
      // width: 50%;
      // height: 100px;
      border-right: 1px solid #efefef;
      flex: auto;
      span {
        color: #c18858;
      }
      p {
        margin-top: 24px;
        color: #000000;
      }
      p:nth-child(1) {
        margin-top: 0;
      }
    }
    .right {
      height: 100px;
      // width: 40%;
      overflow: hidden;
      flex: auto;
      padding-left: 20px;
      span {
        color: #c18858;
        // float: right;
      }
      p {
        margin-top: 24px;
        color: #000000;
      }
      p:nth-child(1) {
        margin-top: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.cooperation-accounts-detail-list-container {
}
</style>
